import { useEffect, useState } from "react";

export function useIsHoverEnabled() {
  const [isHoverEnabled, setIsHoverEnabled] = useState(false);

  useEffect(() => {
    const mediaWatcher = window.matchMedia("(any-hover: hover) and (pointer:fine)");
    setIsHoverEnabled(mediaWatcher.matches);

    function updateIsHoverEnabled(e: MediaQueryListEvent) {
      setIsHoverEnabled(e.matches);
    }

    mediaWatcher.addEventListener('change', updateIsHoverEnabled)

    return () => {
      mediaWatcher.removeEventListener('change', updateIsHoverEnabled)
    }
  }, []);

  return isHoverEnabled;
}